import React from 'react';
import { Box, Skeleton } from '@mui/material';
import { useThemeContext } from '../../hook/useThemeManager';
import { theme } from '../../constants/theme';

interface IRoomItemSkeletonProps {
    showDivider?: boolean;
}

const RoomItemSkeleton: React.FC<IRoomItemSkeletonProps> = ({ showDivider = true }) => {
    const { themeStyle } = useThemeContext();

    return (
        <Box
            sx={{
                p: 2,
                gap: 2,
                display: 'flex',
                alignItems: 'center',
                borderBottom: showDivider ? `1px solid ${theme[themeStyle].grey}40` : 'none',
                bgcolor: 'transparent',
            }}>
            {/* Avatar skeleton */}
            <Skeleton variant="circular" width={48} height={48} />

            {/* Content skeleton */}
            <Box sx={{ flex: 1, minWidth: 0 }}>
                {/* Name and time */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                    <Skeleton variant="text" width={120} height={24} />
                    <Skeleton variant="text" width={50} height={20} />
                </Box>

                {/* Message preview */}
                <Skeleton variant="text" width="80%" height={20} />
            </Box>
        </Box>
    );
};

export default RoomItemSkeleton;
